import React from 'react';
import { BundleProps } from 'utils/types';
import { BingoPopGeneral } from 'templates/Shared/BingoPop';

export const BingoPopBundle: React.FC<BundleProps> = ({
  prices,
  productList,
  backgroundSrc,
  backgroundColor = {
    colorOne: '#E2AE54',
  },
  emblemBadges = [],
}) => {
  return (
    <BingoPopGeneral
      prices={prices}
      productList={productList}
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      emblemBadges={emblemBadges}
    />
  );
};
